import React from 'react';
import './error.css';
import Helmet from "react-helmet/es/Helmet";

class Error extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    render = () => {
//      const error = this.props.error;
        const franchiseData = this.props.franchiseData;
        return (
            <div>
                <Helmet>
                    <title>Customer Self Service / Error</title>
                </Helmet>
                <p className="wth2-errorMessage rea-errorMessage">
                    <strong>We’re sorry.</strong> Payments cannot be processed online at this time. Please
                    call {franchiseData.mainPhoneNumber} to speak with your vacation specialist to make a payment for this
                    booking.
                </p>
            </div>
        );
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.props.onMakeAnotherPaymentSubmit();
    }

    printPage = (event) => {
        window.print();
    }

}

export default Error;
